<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('operatingsystem_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-microsoft-windows</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-operatingsystem-show">
      <v-img
        class = "ma-2"
        max-height="250"
        max-width="250"
        lazy-src="@/assets/imagenotfound.png"
        :key="componentKey"
        :src="imageurlItem"
      >
        <ImageForm
          ref="updateForm"
          :item="item"
          v-if="userHasAccess('operatingsystem_edit')"
        />
          <v-btn
            color="secondary"
            small
            absolute
            bottom
            right
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
      </v-img>
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.operatingsystem.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('global.archive') }}</strong></td>
              <td>
                          {{ item['archive'] }}
              </td>
            </tr>


          </tbody>
        </template>
      </v-simple-table>
    </div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <ProducttypefileList v-if="item"
            ref="ProducttypefileList"
            :operatingSystemParent="[item['@id']]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
            <div v-if="changeLog" class="table-changelog-show">
              <br />
              <Toolbar :handle-edit="() => editSubHandler(changeLog,'ChangeLog')" :hasAccess="userHasAccess('changelog_edit')" >
                <template slot="left">
                  <v-toolbar-title class="hidden-md-and-down">
                    <h1><v-icon large>mdi-math-log</v-icon>{{ $t('version.changelog.changelog') }}</h1>
                  </v-toolbar-title>
                </template>
              </Toolbar>

              <br />
              <v-simple-table>
                <template slot="default">
                  <thead>
                    <tr>
                      <th>{{ $t('global.field') }}</th>
                      <th>{{ $t('global.value') }}</th>

                      <th>{{ $t('global.field') }}</th>
                      <th>{{ $t('global.value') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>{{ $t('version.changelog.name') }}</strong></td>
                      <td>
                                            {{ changeLog['name'] }}
                      </td>

                    </tr>
                    <tr>
              <td><strong>{{ $t('version.changelog.newfeatures') }}</strong></td>
              <td>
                <span  class="tablehtmleditor" v-html="item['changeLog'].newFeatures"></span>
              </td>

              <td><strong>{{ $t('version.changelog.bugfixes') }}</strong></td>
              <td>
                  <span  class="tablehtmleditor" v-html="item['changeLog'].bugFixes"></span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('version.changelog.knownbugs') }}</strong></td>
              <td>
                   <span  class="tablehtmleditor" v-html="item['changeLog'].knownBugs"></span>
              </td>

              <td><strong>{{ $t('version.changelog.notes') }}</strong></td>
              <td>
                  <span  class="tablehtmleditor" v-html="item['changeLog'].notes"></span>
              </td>
            </tr>
                    <tr>
                      <td><strong>{{ $t('version.changelog.developexternal') }}</strong></td>
                      <td>
                                            {{ changeLog['developExternal'] }}
                      </td>

                      <td><strong>{{ $t('version.changelog.developer') }}</strong></td>
                      <td>
                                  <span v-if="changeLog['developer']">{{ changeLog['developer'].login }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>{{ $t('version.changelog.start') }}</strong></td>
                      <td>
                                {{ formatDate(changeLog['start'], 'long') }}
                      </td>

                      <td><strong>{{ $t('version.changelog.end') }}</strong></td>
                      <td>
                                  {{ formatDate(changeLog['end'], 'long') }}
                      </td>
                    </tr>

                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>
        </v-row>
      </v-container>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ImageForm from '../../components/ImageForm.vue';
import FileMixin from '../../mixins/FileMixin';
import ProducttypefileList from '../producttypefile/List';

const servicePrefix = 'OperatingSystem';

export default {
  name: 'OperatingSystemShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageForm,
      ProducttypefileList
  },
  data: () => ({
    filter: '250x250',
    changeLogData: null,
  }),
  mounted() {
    this.operatingsystemGetSubItem({id: this.item['@id'], data: 'change_log'});
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('operatingsystem', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('operatingsystem', ['find']),
    ...mapGetters('operatingsystem',{
      dataOperatingSystem: 'data',
    }),
    ...mapState('operatingsystem', {
      updatedata: 'updatedata',
      error: 'error',
      isLoading: 'isLoading',
    }),
    changeLog: {
      get() { return this.changeLogData },
       set(value) { this.changeLogData = value; }
    }
  },
  methods: {
    ...mapActions('operatingsystem', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    }),
    ...mapActions({
      operatingsystemGetSubItem: 'operatingsystem/subItem'
    }),
  },
  watch: {
    updatedata: function (updatedata) {
      if (this.item) {
        if (updatedata == this.item['@id']+ '/'+ 'change_log') {
          this.changeLog = this.dataOperatingSystem(this.item['@id']+ '/'+ 'change_log');
        }
      }
    },
    item: function (item) {

      if(item) {
        if (! this.dataOperatingSystem(item['@id']+ '/'+ 'change_log')) {
          this.operatingsystemGetSubItem({id: item['@id'], data: 'change_log'});
        } else {
          this.changeLog = this.dataOperatingSystem(this.item['@id']+ '/'+ 'change_log');
        }
      }
    }
  }
};
</script>
